import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { AuthProvider, useAuth } from './contexts/auth';
import { MenuContextProvider } from './contexts/menuContextProvider';
import { NavigationProvider } from './contexts/navigation';

import { useScreenSizeClass } from './utils/media-query';
import setAuthToken from './utils/setAuthToken';

import LoadPanel from './components/load-panel/LoadPanel';
import CookieConsent from './contexts/CookieConsent';
import { NotificationProvider } from './contexts/notification';
import AppTheme from './themes/MuiTheme/AppTheme';

import Content from './Content';
import UnauthenticatedContent from './UnauthenticatedContent';
import SitePopup from './components/PopupScreens/sitePopup';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (user) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();
  const [showPopup, setShowPopup] = useState(true);

  useEffect(() => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }
  }, []);

  return (
    <Router>
      <CookieConsent />
      <AuthProvider>
        <MenuContextProvider>
          <NavigationProvider>
            <AppTheme>
              <SitePopup open={showPopup} onClose={() => setShowPopup(false)} />

              <NotificationProvider>
                <App />
              </NotificationProvider>
            </AppTheme>
          </NavigationProvider>
        </MenuContextProvider>
      </AuthProvider>
    </Router>
  );
}
